import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VentaService } from 'src/app/service/index.service';
import { DetalleVenta, Venta } from 'src/app/model/index.model';
import { ActivatedRoute } from '@angular/router';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss']
})
export class PrintComponent implements OnInit {
  anchoCaracter: number = 62
  arrayAncho: any[] = []
  conf: any
  url: string = environment.configUrl;;
  item: Venta;
  detalle: DetalleVenta[]
  id: number

  constructor(private route: ActivatedRoute, private http: HttpClient, private wsdl: VentaService) {
    this.item = new Venta()
    this.item.id = 1
    this.item.cliente = "CONSUmidor FINAL"
    this.item.condicion = "contado"
    this.item.created_at = '2024-12-16 11:33:00'
    this.detalle = []
  }

  async ngOnInit() {

    await this.http.get(this.url).subscribe(res => {
      this.conf = res;
    });

    this.id = this.route.snapshot.params.id;
    this.findID();
    this.rellenarAncho()
  }

  async findID() {
    try {
      if (this.id > 0) {
        let data = await this.wsdl.doFindByPrint(this.id).then();
        let res = JSON.parse(JSON.stringify(data));
        console.log(res)
        if (res.code == 200) {
          this.item = res.data.venta;
          this.detalle = res.data.detalle
        }
      }
    } catch (error) {
      UturuncoUtils.showToas("Error inesperado", "error");
    }
  }

  rellenarAncho() {
    for (let index = 1; index < this.anchoCaracter; index++) {
      this.arrayAncho.push(index)
    }
  }

  zfill(number, width) {
    width -= number.toString().length;
    if (width > 0) {
      return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
    }
    return number + "";
  }
}
